import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        terceroId: '',
        cementerioId: 1,
        concepto: '-',
        importe: 200,
        serie: '-',
        numero: '',
        observaciones: '-'
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [lugares, setLugares] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const [searchTipo, setSearchTipo] = useState('');
    const [searchLugar, setSearchLugar] = useState('');
    const [filteredTerceros, setFilteredTerceros] = useState([]);
    const [terceroSeleccionado, setTerceroSeleccionado] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [tercerosRes, tiposRes, lugaresRes] = await Promise.all([
                    axios.get('/terceros'),
                    axios.get('/tipos'),
                    axios.get('/lugares')
                ]);
                setTerceros(tercerosRes.data);
                setTipos(tiposRes.data);
                setLugares(lugaresRes.data);
            } catch (error) {
                console.error('Error al obtener los datos:', error);
            }
        };
        fetchData();
    }, []);

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTipoChange = (e) => {
        const selectedTipoId = e.target.value;
        setFormData({ ...formData, tipoId: selectedTipoId });
        setSearchTipo(selectedTipoId);
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleLugarChange = (e) => {
        const selectedLugarId = e.target.value;
        setFormData({ ...formData, lugareId: e.target.value });
        setSearchLugar(e.target.value);
    };
    
   
   /*
    const handleTerceroInputChange = (e) => {
        const searchValue = e.target.value;
        setSearchTercero(searchValue);
    
        // Filtrar solo si el usuario escribe al menos 2 caracteres
        if (searchValue.length >= 2) {
            const filtered = terceros.filter(tercero =>
                tercero.nombre.toLowerCase().includes(searchValue.toLowerCase()) ||
                tercero.documento.includes(searchValue)
            );
            setFilteredTerceros(filtered);
        } else {
            setFilteredTerceros([]); // Limpiar lista si el texto es corto
        }
    };
    
    const handleTerceroSelect = (tercero) => {
        setFormData({ ...formData, terceroId: tercero.documento }); // Guardar el ID
        setSearchTercero(`${tercero.documento}`); // Mostrar en el input
        setFilteredTerceros([]); // Ocultar lista
    };
    */       
    const handleTerceroInputChange = (e) => {
        const searchValue = e.target.value;
        setSearchTercero(searchValue);
    
        if (searchValue.length >= 2) {
            const filtered = terceros.filter(tercero =>
                tercero.nombre.toLowerCase().includes(searchValue.toLowerCase()) ||
                tercero.documento.includes(searchValue)
            );
            setFilteredTerceros(filtered);
        } else {
            setFilteredTerceros([]);
        }
    };
    
    const handleTerceroSelect = (tercero) => {
        setFormData({ ...formData, terceroId: tercero.documento });
        setSearchTercero(`${tercero.documento}`);
        setFilteredTerceros([]);
        setTerceroSeleccionado(tercero.nombre); // ACTUALIZA EL NOMBRE SELECCIONADO
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};

        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredLugares = lugares.filter(lugar => 
        lugar.descripcion.toLowerCase().includes(searchLugar.toLowerCase()) ||
        lugar.id.toString().includes(searchLugar)
    );

/*
    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );
*/
    const filteredTipos = tipos.filter(tipo => 
        tipo.descripcion.toLowerCase().includes(searchTipo.toLowerCase()) ||
        tipo.id.toString().includes(searchTipo)
    );


    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                   
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">Lugar</label>
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción"
                            className="border p-2 rounded w-full"
                            value={searchLugar}
                            onChange={(e) => setSearchLugar(e.target.value)}
                        />
                        <select
                            name="lugareId"
                            value={formData.lugareId}
                            onChange={handleLugarChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un lugar</option>
                            {filteredLugares.map(lugar => (
                                <option key={lugar.id} value={lugar.id}>
                                    {lugar.id} - {lugar.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.lugareId && <p className="text-red-500 text-xs italic">{errors.lugareId}</p>}
                    </div>

                  
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                            Tipo (ID del Tipo Seleccionado)
                        </label>
                        
                     
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción del Tipo"
                            className="border p-2 rounded w-full mt-2"
                            value={searchTipo}
                            onChange={(e) => setSearchTipo(e.target.value)}
                        />
                        

                        <select
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleTipoChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tipo</option>
                            {filteredTipos.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.id} - {tipo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                    </div>


  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
        Buscar y Seleccionar Tercero
    </label>
    <input
        type="text"
        placeholder="Buscar por nombre o documento (mínimo 2 caracteres)"
        className="border p-2 rounded w-full"
        value={searchTercero}
        onChange={handleTerceroInputChange}
        autoComplete="off"
    />
    {filteredTerceros.length > 0 && (
        <ul className="border rounded mt-2 bg-white shadow-md max-h-40 overflow-y-auto">
            {filteredTerceros.map((tercero) => (
                <li
                    key={tercero.documento}
                    onClick={() => handleTerceroSelect(tercero)}
                    className="px-4 py-2 cursor-pointer hover:bg-blue-200"
                >
                    {tercero.nombre} - {tercero.documento}
                </li>
            ))}
        </ul>
    )}

    {/* NUEVA SECCIÓN: Muestra el nombre del tercero seleccionado */}
    {terceroSeleccionado && (
        <p className="mt-2 ">
             {terceroSeleccionado}
        </p>
    )}

    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
</div>




{/*
 <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
        Buscar y Seleccionar Tercero
    </label>
    <input
        type="text"
        placeholder="Buscar por nombre o documento (mínimo 2 caracteres)"
        className="border p-2 rounded w-full"
        value={searchTercero}
        onChange={handleTerceroInputChange}
        autoComplete="off"
    />
    {filteredTerceros.length > 0 && (
        <ul className="border rounded mt-2 bg-white shadow-md max-h-40 overflow-y-auto">
            {filteredTerceros.map((tercero) => (
                <li
                    key={tercero.documento}
                    onClick={() => handleTerceroSelect(tercero)}
                    className="px-4 py-2 cursor-pointer hover:bg-blue-200"
                >
                    {tercero.nombre} - {tercero.documento}
                </li>
            ))}
        </ul>
    )}
    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
</div>

/*}
                                      
  {/*                  
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
*/}
                    
                    {['cementerioId', 'concepto', 'importe', 'serie', 'numero', 'observaciones'].map((key) => (
                        <div key={key} className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                            <input type="text" name={key} value={formData[key]} onChange={handleChange} className="border p-2 rounded w-full" placeholder={`Ingrese ${key}`} />
                        </div>
                    ))}
                </div>
                <div className="flex items-center justify-center">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>{isLoading ? 'Guardando...' : 'Guardar Concesión'}</button>
                </div>
            </form>
        </div>
    );
}



/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: '',
        observaciones: ''
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [lugares, setLugares] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const [searchTipo, setSearchTipo] = useState('');
    const [searchLugar, setSearchLugar] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [tercerosRes, tiposRes, lugaresRes] = await Promise.all([
                    axios.get('/terceros'),
                    axios.get('/tipos'),
                    axios.get('/lugares')
                ]);
                setTerceros(tercerosRes.data);
                setTipos(tiposRes.data);
                setLugares(lugaresRes.data);
            } catch (error) {
                console.error('Error al obtener los datos:', error);
            }
        };
        fetchData();
    }, []);

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTipoChange = (e) => {
        const selectedTipoId = e.target.value;
        setFormData({ ...formData, tipoId: selectedTipoId });
        setSearchTipo(selectedTipoId);
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleLugarChange = (e) => {
        const selectedLugarId = e.target.value;
        setFormData({ ...formData, lugareId: e.target.value });
        setSearchLugar(e.target.value);
    };
    


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};

        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredLugares = lugares.filter(lugar => 
        lugar.descripcion.toLowerCase().includes(searchLugar.toLowerCase()) ||
        lugar.id.toString().includes(searchLugar)
    );


    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );

    const filteredTipos = tipos.filter(tipo => 
        tipo.descripcion.toLowerCase().includes(searchTipo.toLowerCase()) ||
        tipo.id.toString().includes(searchTipo)
    );


    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                   
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">Lugar</label>
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción"
                            className="border p-2 rounded w-full"
                            value={searchLugar}
                            onChange={(e) => setSearchLugar(e.target.value)}
                        />
                        <select
                            name="lugareId"
                            value={formData.lugareId}
                            onChange={handleLugarChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un lugar</option>
                            {filteredLugares.map(lugar => (
                                <option key={lugar.id} value={lugar.id}>
                                    {lugar.id} - {lugar.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.lugareId && <p className="text-red-500 text-xs italic">{errors.lugareId}</p>}
                    </div>

                  
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                            Tipo (ID del Tipo Seleccionado)
                        </label>
                        
                      
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción del Tipo"
                            className="border p-2 rounded w-full mt-2"
                            value={searchTipo}
                            onChange={(e) => setSearchTipo(e.target.value)}
                        />
                        

                        <select
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleTipoChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tipo</option>
                            {filteredTipos.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.id} - {tipo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                    </div>
                    
                                      
                    
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>

                    
                    {['cementerioId', 'concepto', 'importe', 'serie', 'numero', 'observaciones'].map((key) => (
                        <div key={key} className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                            <input type="text" name={key} value={formData[key]} onChange={handleChange} className="border p-2 rounded w-full" placeholder={`Ingrese ${key}`} />
                        </div>
                    ))}
                </div>
                <div className="flex items-center justify-center">
                    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>{isLoading ? 'Guardando...' : 'Guardar Concesión'}</button>
                </div>
            </form>
        </div>
    );
}
*/

/* CORRECTO CON DESPLEGABLES DE TERCERO Y TIPO y LUGARE pero no esta ordenado
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [lugares, setLugares] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const [searchTipo, setSearchTipo] = useState('');
    const [searchLugar, setSearchLugar] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [tercerosRes, tiposRes, lugaresRes] = await Promise.all([
                    axios.get('/terceros'),
                    axios.get('/tipos'),
                    axios.get('/lugares')
                ]);
                setTerceros(tercerosRes.data);
                setTipos(tiposRes.data);
                setLugares(lugaresRes.data);
            } catch (error) {
                console.error('Error al obtener los datos:', error);
            }
        };
        fetchData();
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTipoChange = (e) => {
        const selectedTipoId = e.target.value;
        setFormData({ ...formData, tipoId: selectedTipoId });
     //   setSearchTipo(selectedTipoId);
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleLugarChange = (e) => {
        const selectedLugarId = e.target.value;
        setFormData({ ...formData, lugareId: e.target.value });
        setSearchLugar(e.target.value);
    };

    


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};

        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredLugares = lugares.filter(lugar => 
        lugar.descripcion.toLowerCase().includes(searchLugar.toLowerCase()) ||
        lugar.id.toString().includes(searchLugar)
    );


    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );

    const filteredTipos = tipos.filter(tipo => 
        tipo.descripcion.toLowerCase().includes(searchTipo.toLowerCase()) ||
        tipo.id.toString().includes(searchTipo)
    );

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        key !== 'observaciones' && key !== 'terceroId' && key !== 'tipoId' && (
                            <div key={key} className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <input
                                    type={key === 'importe' ? 'number' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                                    placeholder={`Ingrese ${key}`}
                                />
                                {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
                            </div>
                        )
                    ))}

                   <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">Lugar</label>
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción"
                            className="border p-2 rounded w-full"
                            value={searchLugar}
                            onChange={(e) => setSearchLugar(e.target.value)}
                        />
                        <select
                            name="lugareId"
                            value={formData.lugareId}
                            onChange={handleLugarChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un lugar</option>
                            {filteredLugares.map(lugar => (
                                <option key={lugar.id} value={lugar.id}>
                                    {lugar.id} - {lugar.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.lugareId && <p className="text-red-500 text-xs italic">{errors.lugareId}</p>}
                    </div>


                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                            Tipo (ID del Tipo Seleccionado)
                        </label>
                        
                        
                        <input
                            type="text"
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoId ? 'border-red-500' : ''}`}
                            placeholder="ID del tipo seleccionado"
                        />
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción del Tipo"
                            className="border p-2 rounded w-full mt-2"
                            value={searchTipo}
                            onChange={(e) => setSearchTipo(e.target.value)}
                        />
                        

                        <select
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleTipoChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tipo</option>
                            {filteredTipos.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.id} - {tipo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                    </div>

                  
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/


/* CORRECTO CON DESPLEGABLES DE TERCERO Y TIPO a
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const [searchTipo, setSearchTipo] = useState('');
    const navigate = useNavigate();

    // Fetch de terceros
    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al obtener los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);

    // Fetch de tipos
    useEffect(() => {
        const fetchTipos = async () => {
            try {
                const response = await axios.get('/tipos');
                setTipos(response.data);
            } catch (error) {
                console.error('Error al obtener los tipos:', error);
            }
        };
        fetchTipos();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTipoChange = (e) => {
        const selectedTipoId = e.target.value;
        setFormData({ ...formData, tipoId: selectedTipoId });
     //   setSearchTipo(selectedTipoId);
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};

        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );

    const filteredTipos = tipos.filter(tipo => 
        tipo.descripcion.toLowerCase().includes(searchTipo.toLowerCase()) ||
        tipo.id.toString().includes(searchTipo)
    );

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        key !== 'observaciones' && key !== 'terceroId' && key !== 'tipoId' && (
                            <div key={key} className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <input
                                    type={key === 'importe' ? 'number' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                                    placeholder={`Ingrese ${key}`}
                                />
                                {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
                            </div>
                        )
                    ))}

                   
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                            Tipo (ID del Tipo Seleccionado)
                        </label>
                        
                        
                        <input
                            type="text"
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoId ? 'border-red-500' : ''}`}
                            placeholder="ID del tipo seleccionado"
                        />
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción del Tipo"
                            className="border p-2 rounded w-full mt-2"
                            value={searchTipo}
                            onChange={(e) => setSearchTipo(e.target.value)}
                        />
                        

                        <select
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleTipoChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tipo</option>
                            {filteredTipos.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.id} - {tipo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                    </div>

                  
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const [searchTipo, setSearchTipo] = useState('');
    const navigate = useNavigate();

    // Fetch de terceros
    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al obtener los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);

    // Fetch de tipos
    useEffect(() => {
        const fetchTipos = async () => {
            try {
                const response = await axios.get('/tipos');
                setTipos(response.data);
            } catch (error) {
                console.error('Error al obtener los tipos:', error);
            }
        };
        fetchTipos();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

  
    const handleTipoChange = (e) => {
        const selectedTipoId = e.target.value;
        setFormData({ ...formData, tipoId: selectedTipoId });
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};
        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );

    const filteredTipos = tipos.filter(tipo => 
        tipo.descripcion.toLowerCase().includes(searchTipo.toLowerCase()) ||
        tipo.id.toString().includes(searchTipo)
    );

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        key !== 'observaciones' && key !== 'terceroId' && key !== 'tipoId' && (
                            <div key={key} className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <input
                                    type={key === 'importe' ? 'number' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                                    placeholder={`Ingrese ${key}`}
                                />
                                {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
                            </div>
                        )
                    ))}

                 
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                            Tipo
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por ID o Descripción del Tipo"
                            className="border p-2 rounded w-full"
                            value={searchTipo}
                            onChange={(e) => setSearchTipo(e.target.value)}
                        />
                        <select
                            name="tipoId"
                            value={formData.tipoId}
                            onChange={handleTipoChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tipo</option>
                            {filteredTipos.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.id} - {tipo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                    </div>

                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>
                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/

/* CORRECTO DEPLEGABLE CON EL CAMPO TERCERO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [terceros, setTerceros] = useState([]);
    const [searchTercero, setSearchTercero] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTerceros = async () => {
            try {
                const response = await axios.get('/terceros');
                setTerceros(response.data);
            } catch (error) {
                console.error('Error al obtener los terceros:', error);
            }
        };
        fetchTerceros();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleTerceroChange = (e) => {
        const selectedDocumento = e.target.value;
        setFormData({ ...formData, terceroId: selectedDocumento });
        setSearchTercero(selectedDocumento);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};
        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const filteredTerceros = terceros.filter(tercero => 
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
        tercero.documento.includes(searchTercero)
    );

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        key !== 'observaciones' && key !== 'terceroId' && (
                            <div key={key} className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <input
                                    type={key === 'importe' ? 'number' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                                    placeholder={`Ingrese ${key}`}
                                />
                                {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
                            </div>
                        )
                    ))}
                    
                    
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero
                        </label>
                        <input
                            type="text"
                            placeholder="Buscar por Tercero"
                            className="border p-2 rounded w-full"
                            value={searchTercero}
                            onChange={(e) => setSearchTercero(e.target.value)}
                        />
                        <select
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleTerceroChange}
                            className="border p-2 rounded w-full mt-2"
                        >
                            <option value="">Seleccione un tercero</option>
                            {filteredTerceros.map(tercero => (
                                <option key={tercero.documento} value={tercero.documento}>
                                    {tercero.nombre} - {tercero.documento}
                                </option>
                            ))}
                        </select>
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>
                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/


/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = {};
        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/concesiones', formData);
                navigate('/home/concesiones');
            } catch (err) {
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Object.keys(formData).map((key) => (
                        key !== 'observaciones' && (
                            <div key={key} className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </label>
                                <input
                                    type={key === 'importe' ? 'number' : 'text'}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                                    placeholder={`Ingrese ${key}`}
                                />
                                {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
                            </div>
                        )
                    ))}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>
                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}

*/


/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddConcesionForm() {
    const [formData, setFormData] = useState({
        lugareId: '',
        tipoId: '',
        observaciones: '',
        terceroId: '',
        cementerioId: '',
        concepto: '',
        importe: '',
        serie: '',
        numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

   
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    
        console.log(`Campo: ${name}, Valor: ${value}`); // Muestra el campo y su valor
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación básica
        const validationErrors = {};
        if (!formData.lugareId) validationErrors.lugareId = 'El campo Lugar ID es obligatorio.';
        if (!formData.tipoId) validationErrors.tipoId = 'El campo Tipo ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
        if (!formData.serie) validationErrors.serie = 'El campo Serie es obligatorio.';
        if (!formData.numero) validationErrors.numero = 'El campo Número es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                // Enviar datos al backend
                await axios.post('/concesiones', {
                    lugareId: parseInt(formData.lugareId, 10),
                    tipoId: parseInt(formData.tipoId, 10),
                    observaciones: formData.observaciones || '',
                    terceroId: formData.terceroId, // No convertir a número, ya que puede ser un string alfanumérico
                    cementerioId: parseInt(formData.cementerioId, 10),
                    concepto: formData.concepto,
                    importe: parseFloat(formData.importe), // Convertir a número decimal
                    serie: formData.serie,
                    numero: parseInt(formData.numero, 10)
                });
                navigate('/home/concesiones');
            } catch (err) {
                console.error('Error saving concesion:', err);
                setErrors({ submit: 'Error al guardar la concesión. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nueva Concesión</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lugareId">
                        Lugar ID
                    </label>
                    <input
                        type="text"
                        name="lugareId"
                        value={formData.lugareId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.lugareId ? 'border-red-500' : ''}`}
                        placeholder="Lugar ID de la concesión"
                    />
                    {errors.lugareId && <p className="text-red-500 text-xs italic">{errors.lugareId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipoId">
                        Tipo ID
                    </label>
                    <input
                        type="text"
                        name="tipoId"
                        value={formData.tipoId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.tipoId ? 'border-red-500' : ''}`}
                        placeholder="Tipo ID de la concesión"
                    />
                    {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Observaciones de la concesión"
                    />
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                        Tercero ID
                    </label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.terceroId ? 'border-red-500' : ''}`}
                        placeholder="Tercero ID de la concesión"
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
                        Cementerio ID
                    </label>
                    <input
                        type="text"
                        name="cementerioId"
                        value={formData.cementerioId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
                        placeholder="Cementerio ID de la concesión"
                    />
                    {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
                </div>
            
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="concepto">
                        Concepto
                    </label>
                    <input
                        type="text"
                        name="concepto"
                        value={formData.concepto}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.concepto ? 'border-red-500' : ''}`}
                        placeholder="Concepto de la concesión"
                    />
                    {errors.concepto && <p className="text-red-500 text-xs italic">{errors.concepto}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="importe">
                        Importe
                    </label>
                    <input
                        type="number"
                        name="importe"
                        value={formData.importe}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.importe ? 'border-red-500' : ''}`}
                        placeholder="Importe de la concesión"
                        step="0.01"
                    />
                    {errors.importe && <p className="text-red-500 text-xs italic">{errors.importe}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="serie">
                        Serie
                    </label>
                    <input
                        type="text"
                        name="serie"
                        value={formData.serie}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.serie ? 'border-red-500' : ''}`}
                        placeholder="Serie de la concesión"
                    />
                    {errors.serie && <p className="text-red-500 text-xs italic">{errors.serie}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="numero">
                        Número
                    </label>
                    <input
                        type="text"
                        name="numero"
                        value={formData.numero}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.numero ? 'border-red-500' : ''}`}
                        placeholder="Número de la concesión"
                    />
                    {errors.numero && <p className="text-red-500 text-xs italic">{errors.numero}</p>}
                </div>
                
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/